import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const StyledInput = styled.input`
  && {
    flex-grow: 1;
    cursor: grab;
    ${Styles.SizeStyles}
    ${Styles.FontStyles}
    text-align: ${({ styleProps }) => styleProps?.textAlign || 'left'};
    padding: ${({ renderMode }) => (renderMode === 'mobile' ? '4px 8px' : '2px 4px')};
    ${Styles.BorderStyles}
  }
`;